import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

const UpcomingAuditionIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width="33" height="32" viewBox="0 0 33 32" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="2qmdt9n60a">
          <stop stopColor="#04AA69" offset="0%" />
          <stop stopColor="#007E54" offset="99.901%" />
        </linearGradient>
      </defs>
      <path
        d="M7.266 0v2.344h15.468V0h2.344v2.344h1.406A3.52 3.52 0 0 1 30 5.859l.001 11.077-.245-.117a8.5 8.5 0 1 1-11.938 11.935c.2.435.434.852.698 1.247l-15-.001A3.52 3.52 0 0 1 0 26.484V5.86a3.52 3.52 0 0 1 3.516-3.515h1.406V0h2.344zM24.5 17a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm.5 2v4.6l3.158 3.387-.731.682-3.41-3.656.012-.013H24v-5h1zm2.656-7.984H2.344v15.468c0 .647.525 1.172 1.172 1.172h13.568a8.443 8.443 0 0 1-.915-2.46h-2.34v-2.344h2.195a8.504 8.504 0 0 1 4.83-7.033l-2.338.001v-2.343h2.343v2.34a8.44 8.44 0 0 1 2.345-.719v-1.621h2.343v1.587c.736.09 1.443.275 2.11.541v-4.59zM6.796 22.852v2.343H4.454v-2.343h2.344zm4.688 0v2.343H9.141v-2.343h2.343zm-4.687-4.688v2.344H4.453v-2.344h2.344zm4.687 0v2.344H9.141v-2.344h2.343zm4.688 0v2.344h-2.344v-2.344h2.344zm-9.375-4.687v2.343H4.453v-2.343h2.344zm4.687 0v2.343H9.141v-2.343h2.343zm4.688 0v2.343h-2.344v-2.343h2.344zm-11.25-8.79H3.516c-.647 0-1.172.526-1.172 1.172v2.813h25.312V5.859c0-.646-.525-1.171-1.172-1.171h-1.406V7.03h-2.344V4.688H7.266V7.03H4.922V4.688z"
        fill="url(#2qmdt9n60a)"
        fillRule="nonzero"
      />
    </SvgIcon>
  );
};

export default UpcomingAuditionIcon;
